export class ScrollTo{
	init(){
		$('.scroll-to a').on('click', function(e){
			e.preventDefault();
			var distElement 		= $(this).attr('href'),
					distElementTop 	= $(distElement).offset().top - 15;
			
			$('html, body').animate({
				scrollTop: distElementTop
			}, 500);
		});
	}
}